import moment from 'moment';

let getUtcOffset = (date: any, offset: number) => {
    return moment(date)
        .add(
            offset,
            'minutes')
        .utc()
}

export const localDate = (timeStr: string, format?: string | null, additionalHours?: number) => {
    let localTimeOutput = timeStr;
    let _format = format || "DD/MM/YYYY"

    try {
        if (timeStr) {
            let utcoffset = moment().utcOffset();
            let localTime = getUtcOffset(timeStr, utcoffset);
            if (localTime.isValid()) {
                localTimeOutput = localTime.format(_format);
                localTimeOutput = localTime.add(additionalHours || 0, 'hours').format(_format);
            }
        }
    } catch (err) {
        return localTimeOutput;
    }

    return localTimeOutput;
}

export const getUtcTimeFromCurrentTimeAndHour = (utcTimeStr: string, inc_ora: string) => {

    const inc_ora_arr = inc_ora && inc_ora.split(':');
    if (!inc_ora_arr || !(inc_ora_arr.length > 1)) {
        return utcTimeStr
    }
    const hh = +inc_ora_arr[0]
    const mm = +inc_ora_arr[1]
    if (isNaN(hh) || isNaN(mm)) {
        return utcTimeStr
    }
    
    const retTime = new Date(utcTimeStr)
    retTime.setHours(hh, mm, 0)
    return retTime.toISOString()
}

export const localTimeHour = (timeStr: string) => {
    return localDate(timeStr, 'HH:mm')
}

export const caiExpireLocalDate = (textIn: string) => {
    const additionalHours = +((window.REACT_APP_CAI_COMMUNICATION_EXPIRATION_IN) || 48);
    return localDate(textIn, 'DD/MM/YYYY', additionalHours);
}

export const caiSignatureFeedbackExpireDate = (textIn: string) => {
    const additionalHours = +((window.REACT_APP_CAI_SIGNATURE_EXPIRATION_IN) || 48);
    return localDate(textIn, 'DD/MM/YYYY', additionalHours);
}

export const isExpired48h = (creationDate?: string) => {
    if (!creationDate) {
        return true; // Se non c'è data, considera scaduto
    }
    
    try {
        const creationTimestamp = new Date(creationDate).getTime();
        
        // Controlla se la data è valida
        if (isNaN(creationTimestamp)) {
            return true; // Data non valida, considera scaduto
        }
        
        const nowTimestamp = Date.now();
        const diffInMilliseconds = nowTimestamp - creationTimestamp;
        const diffInHours = diffInMilliseconds / (1000 * 60 * 60); // Converte ms in ore
        
        return diffInHours >= 48;
    } catch (err) {
        console.error('Errore nel calcolo scadenza 48h:', err);
        return true; // In caso di errore, considera scaduto per sicurezza
    }
}

